export const GET_LIST_REQUEST = "Permissions/GET_LIST_REQUEST";
export const GET_LIST_SUCCESS = "Permissions/GET_LIST_SUCCESS";
export const GET_LIST_FAILURE = "Permissions/GET_LIST_FAILURE";